import React, { useState } from 'react';
import cx from 'classnames';
import Modal from '../../../../../components/Modal/Modal';
import Button from '../../../../../components/Button';
import InfoTable from '../../../../../components/table/InfoTable';
import { VALID_FILTER } from '../../../../../constants/service/common/utilConstants';
import { setDash } from '../../../../../lib/common';
import {
  INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TEXT,
  VALID_EXCEL_UPLOAD_COUPON_CASE_TEXT,
  INVALID_EXCEL_UPLOAD_COUPON_CASE_TEXT,
} from '../../../../../constants/service/app/couponConstants';
import './ExcelUploadCouponProductValidFailModal.scss';

const ExcelUploadCouponProductValidFailModal = (props) => {
  const { isOpen, data, closeModal, onSubmit, handleDownloadInvalidItems } = props;
  const { productList, requestCnt, possibleCnt, impossibleCnt } = data;
  const [validFilterValue, setValidFilterValue] = useState(VALID_FILTER.ALL);

  const validFilter = (item) => {
    if (validFilterValue === VALID_FILTER.VALID) {
      return !item.productIsInvalid;
    } else if (validFilterValue === VALID_FILTER.INVALID) {
      return item.productIsInvalid;
    }

    return true;
  };

  return (
    <Modal
      title="쿠폰 사용 가능한 상품 엑셀 업로드 불가능"
      isOpen={isOpen}
      width={800}
      height={600}
      isFooter={true}
      okText="확인"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="excel-upload-coupon-product-valid-fail-modal-wrap">
        <div className="excel-upload-coupon-product-valid-fail-title">
          <div className="summary">
            <button
              type="button"
              className="request"
              onClick={() => {
                setValidFilterValue(VALID_FILTER.ALL);
              }}
            >
              요청:
              <span>{requestCnt}</span>
            </button>
            <button
              type="button"
              className="possible"
              onClick={() => {
                setValidFilterValue(VALID_FILTER.VALID);
              }}
            >
              가능:
              <span>{possibleCnt}</span>
            </button>
            <button
              type="button"
              className="impossible"
              onClick={() => {
                setValidFilterValue(VALID_FILTER.INVALID);
              }}
            >
              불가능:
              <span>{impossibleCnt}</span>
            </button>
          </div>

          <div>엑셀 업로드에 실패했습니다.</div>
          <div>아래 리스트에서 실패한 결과를 확인하시고,</div>
          <div>
            <span>수정을 한 뒤 다시 시도해주세요.</span>
          </div>
        </div>

        <div className="download-section">
          <Button color="primary" onClick={handleDownloadInvalidItems} text="불가능 항목 다운로드" />
        </div>

        <div className="excel-upload-coupon-product-valid-fail-list-section">
          <InfoTable>
            <thead>
              <tr>
                <th>순번</th>
                <th>유효성 검사 결과</th>
                <th className="invalid-message">상품 번호</th>
              </tr>
            </thead>
            <tbody>
              {productList.filter(validFilter).map((item, index) => (
                <tr key={index}>
                  <td className="tc">{index + 1}</td>
                  <td className={cx('result', { isInvalid: item.productIsInvalid })}>
                    {item.productIsInvalid
                      ? INVALID_EXCEL_UPLOAD_COUPON_CASE_TEXT
                      : VALID_EXCEL_UPLOAD_COUPON_CASE_TEXT}
                  </td>
                  <td className="tc">
                    {setDash(item.productId)}
                    <div className="message">
                      {item.productIsInvalid
                        ? INVALID_COUPON_PRODUCT_ITEM_EXCEL_UPLOAD_CASE_TEXT[item.productInvalidType]
                        : ''}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </Modal>
  );
};

export default ExcelUploadCouponProductValidFailModal;
